import axios from "axios";
import { getToken, clearAuth } from "../utils/auth";
import { isTokenExpired } from "../utils/jwt";

const enableLogs = process.env.REACT_APP_ENABLE_API_LOGS === "true" || process.env.NODE_ENV === "development";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (enableLogs) {
      const ts = new Date().toISOString();
      console.debug(`[API ${ts}] ${config.method?.toUpperCase()} ${config.baseURL || ""}${config.url || ""}`);
    }
    return config;
  },
  (error) => {
    if (enableLogs) {
      console.error("[API] Request setup error:", error.message || error);
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (enableLogs) {
      const ts = new Date().toISOString();
      console.debug(`[API ${ts}] OK ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error) => {
    if (enableLogs) {
      const ts = new Date().toISOString();
      const status = error.response?.status || "N/A";
      const url = error.config?.url || "unknown";

      if (!error.response) {
        if (error.code === "ECONNABORTED") {
          console.error(`[API ${ts}] TIMEOUT ${url} — request exceeded 30s`);
        } else if (error.code === "ERR_NETWORK") {
          console.error(`[API ${ts}] NETWORK ERROR ${url} — server unreachable or CORS blocked`);
        } else {
          console.error(`[API ${ts}] CONNECTION FAILED ${url}:`, error.message || error);
        }
      } else {
        console.error(`[API ${ts}] ERROR ${status} ${url}:`, error.response?.data || error.message);
      }
    }

    if (error.response?.status === 401) {
      const token = getToken();
      if (token && isTokenExpired(token)) {
        clearAuth();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
